import { useState } from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-async-light'
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism'
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python'
import javascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript'
import http from 'react-syntax-highlighter/dist/esm/languages/prism/http'
SyntaxHighlighter.registerLanguage('python', python)
SyntaxHighlighter.registerLanguage('javascript', javascript)
SyntaxHighlighter.registerLanguage('http', http)
import { Copy, Check, ChevronDown } from 'lucide-react'
import { CLIENT_CODE } from '@/lib/endpoints'

const Code: React.FC<CodeProps> = ({ id }) => {
  const [copied, setCopied] = useState(false)
  const [client, setClient] = useState('python')

  const handleCopy = async () => {
    window.track('code_copied')
    await navigator.clipboard.writeText(CLIENT_CODE[id][client])
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  const clients = Object.keys(CLIENT_CODE[id] ?? [])

  return (
    <div className="relative rounded-lg overflow-hidden border border-neutral-700/50">
      {/* Header */}
      <div className="flex items-center justify-between bg-neutral-800/90 px-4 py-2.5 border-b border-neutral-700/50">
        <span className="text-sm text-neutral-400 font-medium">Sample code</span>

        <div className="relative">
          <label htmlFor="client-select" className="sr-only">
            Select client
          </label>

          <select
            id="client-select"
            value={client}
            onChange={(e) => setClient(e.target.value)}
            className="
            appearance-none
            pl-3 pr-8 py-1.5
            text-sm
            bg-neutral-700/50
            text-neutral-200
            rounded
            border border-neutral-600/50
            hover:bg-neutral-700
            focus:outline-none focus:ring-1 focus:ring-neutral-500
            cursor-pointer
            "
          >
            {clients.map((clientName) => (
              <option key={clientName} value={clientName}>
                {clientName.charAt(0).toUpperCase() + clientName.slice(1)}
              </option>
            ))}
          </select>

          <ChevronDown
            size={14}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-neutral-400 pointer-events-none"
          />
        </div>
      </div>

      {/* Code Block */}
      <div className="relative bg-neutral-900">
        <button
          onClick={handleCopy}
          className="
            absolute top-3 right-3 z-10
            rounded p-2
            bg-neutral-800/60
            text-neutral-400 hover:text-neutral-200
            hover:bg-neutral-700/80
            cursor-pointer
            transition-all
          "
          aria-label="Copy to clipboard"
        >
          {copied ? <Check size={16} /> : <Copy size={16} />}
        </button>

        <SyntaxHighlighter
          language={client}
          style={vscDarkPlus}
          showLineNumbers={true}
          customStyle={{
            margin: 0,
            padding: '1rem',
            background: 'transparent',
            fontSize: '0.875rem',
          }}
          lineNumberStyle={{
            minWidth: '2.5em',
            paddingRight: '1em',
            color: '#6e7681',
            userSelect: 'none'
          }}
        >
          {CLIENT_CODE[id] ? CLIENT_CODE[id][client] : ''}
        </SyntaxHighlighter>
      </div>
    </div>
  )
}

export default Code
